import normalizeComponent from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';

/* script */

/* template */
var __vue_render__ = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"scrollable-div"},[_c('table',[(_vm.props.headings)?_c('thead',[_c('tr',_vm._l((_vm.props.headings),function(heading,index){return _c('th',{key:index},[_vm._v(_vm._s(heading))])}),0)]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.props.body),function(row,index){return _c('tr',{key:index},_vm._l((row),function(item,index){return _c('td',{key:index,domProps:{"innerHTML":_vm._s(_vm.props.sanitize(item))}})}),0)}),0)])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = true;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
